import { connect } from "react-redux";

import Menu, { IMenuProps, IMenuActions } from "./menu";
import { logout } from "../../user/user.actions";
import { navigateTo } from "../../home";

export default connect(
  ({ user }: any): IMenuProps => {
    const { authorization } = user;
    return {
      authorization
    };
  },
  (dispatch: any): IMenuActions => {
    return {
      goHome: () => dispatch(navigateTo("/")),
      handleMyDevices: () => dispatch(navigateTo("/user/devices")),
      handleMyApiKeys: () => dispatch(navigateTo("/user/apikeys")),
      handleChangePassword: () => dispatch(navigateTo("/user/password")),
      handleAdminUsers: () => dispatch(navigateTo("/admin/user")),
      logout: () => dispatch(logout())
    };
  }
)(Menu);
